import { sagas as balanceDetailsSagas } from './modules/balanceDetails'
import { sagas as balanceDueSagas } from './modules/balanceDue'
import { sagas as bulkAvailablePaymentTypesSagas } from './modules/bulkAvailablePaymentTypes'
import { sagas as loadingSagas } from './modules/loading'
import { sagas as productPermissions } from './modules/productPermissions'
import { sagas as propertyContacts } from './modules/propertyContacts'
import { sagas as statesSagas } from './modules/states'
import { sagas as privacyPolicies } from './modules/privacyPolicies'
import { sagas as leasePermissions } from './modules/leasePermissions'
import { sagas as bulkPaymentsList } from './modules/bulkPaymentsList'
import { sagas as bulkPaymentsListModal } from './modules/bulkPaymentsListModal'
import { sagas as bulkPaymentSagas } from 'portal-modules/payments/components/bulk-payments/redux/modules/bulkPayment'
import {sagas as errorsSagas} from 'portal-modules/common/redux/modules/errors'

export default [
  ...balanceDetailsSagas,
  ...balanceDueSagas,
  ...bulkAvailablePaymentTypesSagas,
  ...loadingSagas,
  ...productPermissions,
  ...propertyContacts,
  ...statesSagas,
  ...privacyPolicies,
  ...leasePermissions,
  ...bulkPaymentsList,
  ...bulkPaymentsListModal,
  ...bulkPaymentSagas,
  ...errorsSagas
]
